module.exports = __webpack_public_path__ + "whiteom.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/whiteom.png
// module id = 899
// module chunks = 0